import { Button, Modal, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import errorIcon from '../../../assets/images/octagon-xmark.svg';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { Beneficiario } from '../../../interfaces/entities/Beneficiario';
import { QuestionarioEmailCel } from '../../../interfaces/entities/QuestionarioEmailCel';
import { QuestionarioEmailCelOpcoes } from '../../../interfaces/entities/QuestionarioEmailCelOpcoes';
import { RegistrarBeneficiario } from '../../../interfaces/entities/RegistrarBeneficiario';
import { RecoveryActionEnum } from '../../../interfaces/enum/RecoveryActionEnum';
import { TokenRecoveryType } from '../../../interfaces/enum/TokenRecoveryType';
import { RecuperarSenhaFormProps } from '../../../interfaces/props/RecuperarSenhaFormProps';
import { getQuestRecuperaLogin, getRegistroBeneficiario, postValidarquestionarioemailcel } from '../../../services/LoginService';
import { registerClient } from '../../../services/RegisterService';
import { sendTokenEmailRegistroBeneficiario, sendTokenSMSRegistroBeneficiario } from '../../../services/TokenService';
import { diferencaHorasMinutos } from '../../../utils/CalcDiffHours';
import '../styles.css';
import { sxButtonContained, sxTextButton, sxTypographySubTitle, sxTypographyTitle } from '../sxProps';
import AlertRecoveryQuestions from './AlertRecoveryQuestions';
import ConfirmationDataRecovery from './ConfirmationDataRecovery';
import OptionsRecovery from './OptionsRecovery';
import PasswordRedefinition from './PasswordRedefinition';
import RecoveryForm from './RecoveryForm';
import RecoveryQuestions from './RecoveryQuestions';
import TokenReceived from './TokenReceived';
import QuestionsToRecoveryPassword from './QuestionsToRecoveryPassword';
import { getQuestValidacaoUsrContr, postRespostaQuestValidacaoUsrContr } from '../../../services/QuestionarioService';
import { QuestionarioToPasswordOptions } from '../../../interfaces/entities/QuestionarioToPasswordOptions';
import { QuestionarioToPassword } from '../../../interfaces/entities/QuestionarioToPassword';
import moment from 'moment';

const PasswordRecovery: React.FC<RecuperarSenhaFormProps> = ({ handlerShowRecuperarSenha }) => {
  const [recoveryAction, setRecoveryAction] = useState<RecoveryActionEnum>(RecoveryActionEnum.RecoveryForm);
  const [tokenRecoveryType, setTokenRecoveryType] = useState<TokenRecoveryType>(TokenRecoveryType.Email);
  const [recoveryQuestions, setRecoveryQuestions] = useState<any>([]);
  const [recoveryQuestionsToPassword, setRecoveryQuestionsToPassword] = useState<any>([]);
  const [modalFeedback, setmodalFeedback] = React.useState<null | { icon?: 'error' | 'success', title?: string, textButton?: string, subTitle?: string, action: () => void }>(null);
  const [beneficiario, setBeneficiario] = useState<Beneficiario>();
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [allowAlterData, setAllowAlterData] = useState<boolean>(false);
  const [registerToken, setRegisterToken] = useState<any>();
  const [dtNascimento, setDtNascimento] = useState<string>('');
  const [numCard, setNumCard] = useState<string>('');
  const [cpf, setCpf] = useState<string>('');
  const [openModalTimeQuestions, setOpenModalTimeQuestions] = useState<boolean>(false);
  const [hoursBlocked, setHoursBlocked] = useState<string>('');
  const [tokenQuest, setTokenQuest] = useState<number>(0);

  const openRecoveryValidationData = async (dtNasc: string, cpf: string, numeroCartao: string) => {
    setShowLoading(true);
    setDtNascimento(dtNasc);
    setNumCard(numeroCartao);
    setCpf(cpf);
    await getRegistroBeneficiario(dtNasc, cpf, numeroCartao).then(response => {
      const data: Beneficiario = response?.data[0];
      if (data.status !== "CAD") {
        setmodalFeedback({
          icon: 'error',
          title: 'Ocorreu um erro',
          subTitle: 'Beneficiário não cadastrado',
          textButton: 'Fechar',
          action: () => setmodalFeedback(null)
        });
        setShowLoading(false);
        return;
      }

      if (data.email === "" && data.cel === "") {
        setmodalFeedback({
          icon: 'error',
          title: 'Atenção!',
          subTitle: 'Não conseguimos localizar seus dados de contato para finalizar o cadastro. Por favor, entre em contato conosco pelo 0800 013 66 88 para regularizar.',
          textButton: 'Fechar',
          action: () => setmodalFeedback(null)
        });
        setShowLoading(false);
        return;
      }
      
      setBeneficiario(data);
      setRecoveryAction(RecoveryActionEnum.ConfirmationData);
      setShowLoading(false);
    }).catch(error => {
      setmodalFeedback({
        icon: 'error',
        title: 'Ocorreu um erro',
        subTitle: error.response.data?.mensagem ? error.response.data?.mensagem : 'Beneficiário não localizado',
        textButton: 'Fechar',
        action: () => setmodalFeedback(null)
      });
      setShowLoading(false);
    });
  }

  const isValidDate = (dateString: string) => {
    var date = moment(dateString, "DD/MM/YYYY HH:mm:ss", true);
    return date.isValid();
  }


  const openRecoveryQuestions = async () => {

    if (beneficiario) {
      setShowLoading(true);

      var response = await getQuestRecuperaLogin(beneficiario.idUsrContr.toString()/* , beneficiario.login */);

      if (response?.status !== 200) {
        if (isValidDate(response?.mensagem || "")) {
          setHoursBlocked(response?.mensagem);
          setOpenModalTimeQuestions(true);
        } else {
          setmodalFeedback({
            icon: 'error',
            title: 'Ocorreu um erro',
            subTitle: 'Erro ao buscar perguntas de segurança',
            textButton: 'Fechar',
            action: () => setmodalFeedback(null)
          });
          setShowLoading(false);

        }
        return;
      }

      setRecoveryQuestions(response?.data);
      setRecoveryAction(RecoveryActionEnum.RecoveryQuestions)
    }
    setShowLoading(false);

  }


  const openRecoveryOptions = (email: string, celular: string) => {
    var benef = beneficiario;
    if (benef) {
      benef.cel = celular;
      benef.email = email;
    }
    setBeneficiario(benef);
    setRecoveryAction(RecoveryActionEnum.RecoveryOptions)
  }

  const openAlertRecoveryQuestions = () => {
    setRecoveryAction(RecoveryActionEnum.AlertRecoveryQuestions)
  }

  const openPasswordRedefinition = () => {
    setRecoveryAction(RecoveryActionEnum.PasswordRedefinition)
  }

  const validateQuestiosToRecovery = async (listAnswersOptions: Array<QuestionarioToPasswordOptions>) => {
    setShowLoading(true);

    var questionario: QuestionarioToPassword = {
      idOperador: parseInt(beneficiario?.idOperador || '0'),
      idUsrContr: beneficiario?.idUsrContr.toString() || '',
      key: recoveryQuestionsToPassword.key,
      qtde: 0,
      respostas: listAnswersOptions
    }
    var response = await postRespostaQuestValidacaoUsrContr(questionario);

    if (response?.status !== 200) {
      setmodalFeedback({
        icon: 'error',
        title: 'Dados inválidos',
        subTitle: response?.mensagem ? response?.mensagem : 'Confira os dados preenchidos e tente novamente.',
        textButton: 'Fechar',
        action: () => {
          setmodalFeedback(null)
          setRecoveryAction(RecoveryActionEnum.RecoveryOptions)
        }
      });
      setShowLoading(false);
      return
    }

    setTokenQuest(response.data.tokenQuest);
    openPasswordRedefinition();
    setShowLoading(false);
  }

  const openQuestionsToRecoveryPassword = async () => {
    if (beneficiario) {
      setShowLoading(true);

      var response = await getQuestValidacaoUsrContr(beneficiario.idUsrContr.toString());

      if (response?.status !== 200) {
        setmodalFeedback({
          icon: 'error',
          title: 'Tente novamente mais tarde',
          subTitle: response?.mensagem ? response?.mensagem : 'Erro ao buscar perguntas de segurança',
          textButton: 'Fechar',
          action: () => setmodalFeedback(null)
        });
        setShowLoading(false);
        return;
      }

      setRecoveryQuestionsToPassword(response?.data);
      setRecoveryAction(RecoveryActionEnum.QuestionsToRecovery)
    }
    setShowLoading(false);


  }

  const handleSelectTokenType = async (type: TokenRecoveryType) => {
    setTokenRecoveryType(type);
    setRecoveryAction(RecoveryActionEnum.TokenReceived);

    switch (type) {
      case TokenRecoveryType.Email:
        const responseEmail = await sendTokenEmailRegistroBeneficiario({
          tipoToken: type.toString(),
          idUsrContr: beneficiario?.idUsrContr.toString(),
          nome: beneficiario?.nome,
          email: beneficiario?.email,
        });

        if (responseEmail?.status !== 200) {
          setmodalFeedback({
            icon: 'error',
            title: 'Ocorreu um erro',
            subTitle: 'Erro ao enviar e-mail',
            textButton: 'Fechar',
            action: () => setmodalFeedback(null)
          });
          return
        }

        setRegisterToken(responseEmail?.data);
        return
      case TokenRecoveryType.SMS:
        const responseSMS = await sendTokenSMSRegistroBeneficiario({
          tipoToken: type.toString(),
          idUsrContr: beneficiario?.idUsrContr.toString(),
          cel: beneficiario?.cel,
        })

        if (responseSMS?.status !== 200) {
          setmodalFeedback({
            icon: 'error',
            title: 'Ocorreu um erro',
            subTitle: 'Erro ao enviar SMS',
            textButton: 'Fechar',
            action: () => setmodalFeedback(null)
          });
          return
        }

        setRegisterToken(responseSMS?.data);
        return
      default:
        return
    }
  }

  const formBack = () => {
    switch (recoveryAction) {
      case RecoveryActionEnum.RecoveryOptions:
        setRecoveryAction(RecoveryActionEnum.ConfirmationData)
        break;
      case RecoveryActionEnum.RecoveryQuestions:
        setRecoveryAction(RecoveryActionEnum.AlertRecoveryQuestions)
        break;
      case RecoveryActionEnum.TokenReceived:
        setRecoveryAction(RecoveryActionEnum.RecoveryOptions)
        break;
      case RecoveryActionEnum.PasswordRedefinition:
        setRecoveryAction(RecoveryActionEnum.RecoveryOptions)
        break;
      case RecoveryActionEnum.AlertRecoveryQuestions:
        setRecoveryAction(RecoveryActionEnum.ConfirmationData)
        break;
      case RecoveryActionEnum.ConfirmationData:
        setRecoveryAction(RecoveryActionEnum.RecoveryForm)
        break;
      case RecoveryActionEnum.QuestionsToRecovery:
        setRecoveryAction(RecoveryActionEnum.RecoveryOptions)
        break;
    }
  }

  const allowChangeData = async (listAnswersOptions: Array<QuestionarioEmailCelOpcoes>) => {
    setShowLoading(true);

    var questionario: QuestionarioEmailCel = {
      listaOpcoes: listAnswersOptions,
      idUsrContr: beneficiario?.idUsrContr.toString() || ''
    }
    var response = await postValidarquestionarioemailcel(questionario);

    if (response?.status !== 200) {
      setmodalFeedback({
        icon: 'error',
        title: 'Dados inválidos',
        subTitle: 'Confira os dados preenchidos e tente novamente.',
        textButton: 'Fechar',
        action: () => setmodalFeedback(null)
      });
      setShowLoading(false);
      return
    }

    if (response.data.questionarioValid === "OK") {
      setAllowAlterData(true);
      setRecoveryAction(RecoveryActionEnum.ConfirmationData)

    } else {
      setHoursBlocked(diferencaHorasMinutos(new Date(), response.data.dtBloqueio));
      setOpenModalTimeQuestions(true);
    }
    setShowLoading(false);
  }

  const backToLogin = () => {
    window.location.reload();
  }

  const passwordRegister = async (password: string) => {
    setShowLoading(true)
    if (beneficiario) {
      const registrarBeneficiario: RegistrarBeneficiario = {
        cel: beneficiario.cel,
        cpf: cpf,
        dtNasc: dtNascimento,
        email: beneficiario.email,
        emailConf: beneficiario.email,
        numeroCartao: numCard,
        senha: password,
        senhaConfirmacao: password,
        tel: beneficiario.tel,
        tokenSMS: registerToken?.numeroTokenUnimed || "",
        tokenQuest: tokenQuest
      }
      const response = await registerClient(registrarBeneficiario);

      if (response !== 'OK') {
        setmodalFeedback({
          icon: 'error',
          title: 'Ocorreu um erro',
          subTitle: 'Erro ao registrar beneficiário',
          textButton: 'Fechar',
          action: () => setmodalFeedback(null)
        });
        setShowLoading(false);
      } else {
        setmodalFeedback({
          icon: 'success',
          title: 'Senha redefinida com sucesso',
          subTitle: '',
          textButton: 'FAZER LOGIN',
          action: () => backToLogin()
        });
        setShowLoading(false);
      }
    }
    setShowLoading(false);
  }

  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  return (
    <>
      <LoadingApp showLoading={showLoading} />
      {(() => {
        switch (recoveryAction) {
          case RecoveryActionEnum.RecoveryForm:
            return <RecoveryForm
              handlerShowRecuperarSenha={handlerShowRecuperarSenha}
              openRecoveryValidationData={openRecoveryValidationData}
            />;

          case RecoveryActionEnum.RecoveryOptions:
            return <OptionsRecovery
              formBack={formBack}
              openTokenReceived={handleSelectTokenType}
              openQuestionsToRecoveryPassword={openQuestionsToRecoveryPassword}
            />;

          case RecoveryActionEnum.TokenReceived:
            return <TokenReceived
              formBack={formBack}
              openPasswordRedefinition={openPasswordRedefinition}
              tokenRecoveryType={tokenRecoveryType}
              openTokenReceived={handleSelectTokenType}
              registerToken={registerToken}
            />;

          case RecoveryActionEnum.RecoveryQuestions:
            return <RecoveryQuestions
              questions={recoveryQuestions}
              formBack={formBack}
              allowChangeData={allowChangeData}
            />;

          case RecoveryActionEnum.PasswordRedefinition:
            return <PasswordRedefinition
              formBack={formBack}
              passwordRegister={passwordRegister}
            />;

          case RecoveryActionEnum.AlertRecoveryQuestions:
            return <AlertRecoveryQuestions
              formBack={formBack}
              openRecoveryQuestions={openRecoveryQuestions}
            />;

          case RecoveryActionEnum.ConfirmationData:
            return <ConfirmationDataRecovery
              formBack={formBack}
              beneficiario={beneficiario}
              allowAlterData={allowAlterData}
              openAlertRecoveryQuestions={openAlertRecoveryQuestions}
              openRecoveryOptions={openRecoveryOptions}
            />;

          case RecoveryActionEnum.QuestionsToRecovery:
            return <QuestionsToRecoveryPassword
              formBack={formBack}
              questions={recoveryQuestionsToPassword.questoes}
              validateQuestiosToRecovery={validateQuestiosToRecovery}
            />;
        }
      })()}
      <ModalFeedBack
        showModal={modalFeedback ? true : false}
        icon={modalFeedback?.icon as 'success' | 'error'}
        textButton={modalFeedback?.textButton as string}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        handleShowModal={modalFeedback?.action}
        showButtonModal
        handleButtonModal={modalFeedback?.action}
        classNameModal='modal-feedback-mobile'
      />
      <Modal
        open={openModalTimeQuestions}
        onClose={() => backToLogin()}
      >
        <div style={textStyleAccessibility} className='container-modal' >
          <div>
            <img src={errorIcon} alt="Icone de erro." />
          </div>
          <div >
            <Typography sx={sxTypographyTitle}>{'Revalidação de dados'}</Typography>
            <p />
            <Typography sx={sxTypographySubTitle}>Uma ou mais perguntas foram respondidas de forma incorreta e, por isso, o cadastro{' '}<span style={{ fontWeight: 'bold', fontFamily: 'UnimedSans-bold' }}>ficará bloqueado por {hoursBlocked} horas.</span></Typography>
            <Typography sx={sxTypographySubTitle}>{'Após este período, você pode realizar uma nova tentativa.'}</Typography>
          </div>
          <div className='container-button'>
            <Button
              style={buttonStyleAccessibility}
              onClick={() => backToLogin()}
              sx={sxButtonContained}
              variant={"contained"}
            >
              <Typography style={buttonTextStyleAccessibility} sx={sxTextButton}>{'Voltar'}</Typography>
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PasswordRecovery;
